<template>
  <v-toolbar fixed app color="info">
      <v-list>
      <v-list-tile-title dark class='title'>
        Community
      </v-list-tile-title>
    </v-list>
  </v-toolbar>
</template>
<script>
export default {
  name: 'chat-bar'
}
</script>



// WEBPACK FOOTER //
// src/components/user/ChatBar.vue